import ReactDOM from 'react-dom/client';
import './shared/styles/index.css';
import App from './app/App';
import reportWebVitals from './app/bootstrap/reportWebVitals';
// Used Bootstrap rules only; generated by `npm start` / `npm run build`.
import './shared/styles/generated/bootstrap-subset.css';
import { Provider } from 'react-redux';
import { store, persistor } from './app/store/store';
import { PersistGate } from 'redux-persist/integration/react';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
